import { LoginPage } from './LoginPage'

export { LoginPage }



// WEBPACK FOOTER //
// ./client/Modules/LoginPage/LoginPage/index.js